import React from "react";
import { MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface ChatStatusIndicatorProps {
  unreadCount: number;
  className?: string;
}

const ChatStatusIndicator = ({ unreadCount, className }: ChatStatusIndicatorProps) => {
  if (!unreadCount || unreadCount <= 0) return null;

  return (
    <div className={cn("relative inline-flex items-center", className)}>
      <div className="flex items-center gap-1 bg-[#25D366] text-white text-[11px] font-bold rounded-full px-2 py-0.5 shadow-sm">
        <MessageCircle className="h-3.5 w-3.5 fill-current" />
        <span>{unreadCount}</span>
      </div>
    </div>
  );
};

export default ChatStatusIndicator;
